function cacheHas(cache, key) {
  return cache.has(key);
}
export {
  cacheHas as default
};
//# sourceMappingURL=_cacheHas.js.map
